import { injectable } from 'tsyringe';
import type { CostForecastSnapshot } from '@bmai/insights-api-client';
import { insightsClient } from '@/shared/InsightsApiClient';

/** Reads the authoritative cost-forecast snapshot for the signed-in user's tenant from bmai-insights (computed nightly, on-demand on a miss). */
@injectable()
export class CostForecastGateway {
    private readonly api = insightsClient.insightsApi;

    getForecast(): Promise<CostForecastSnapshot> {
        return this.api.getCostForecast();
    }
}
